import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { ErrorHelper } from '@shared/helpers/error.helper';
import { MessageHelper, MessageTypeEnum } from '@shared/helpers/message.helper';
import { INotificationSettings } from '@shared/models/interfaces/INotificationSettings';
import { AuthService } from '@shared/services/auth.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit, OnDestroy {
  private saveSubject = new Subject();

  list: INotificationSettings[] = [];
  selecteds: number[] = [];

  constructor(
    private messageHelper: MessageHelper,
    private errorHelper: ErrorHelper,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.loadSettings();

    this.saveSubject.pipe(debounceTime(1000)).subscribe(() => this.update());
  }

  ngOnDestroy() {
    this.saveSubject.complete();
  }

  handleSelect(id: number) {
    const index = this.selecteds.indexOf(id);

    if (index === -1) this.selecteds.push(id);
    else this.selecteds.splice(index, 1);

    this.handleSave();
  }

  handleSelectAll() {
    const selected = this.isAllSelecteds();
    this.selecteds = selected ? [] : this.list.map((x) => x.id);

    this.handleSave();
  }

  isSelected(id: number) {
    return this.selecteds.includes(id);
  }

  isAllSelecteds() {
    return this.selecteds.length === this.list.length;
  }

  private handleSave() {
    this.saveSubject.next();
  }

  async update() {
    try {
      await this.authService.updateNotificationSettings(this.selecteds);
      this.messageHelper.send(
        'Notifications updated.',
        MessageTypeEnum.success
      );
    } catch (err) {
      this.errorHelper.catch(err);
    } finally {
    }
  }

  private async loadSettings() {
    try {
      const { notifications } = await this.authService.getUserSettings();
      this.list = notifications;
      this.selecteds = notifications.filter((x) => x.selected).map((x) => x.id);
    } catch (error) {
      this.errorHelper.catch(error);
    } finally {
    }
  }
}
